import { useQuery,useQueryClient,useMutation } from '@tanstack/react-query';
import { supabase } from '../utils/supabase/client';
import { useState,useEffect } from 'react';
import { supabaseFreeTable } from '../utils/supabase/clientFreeTable';


export const useSignIn = () => {
    return useMutation({
      mutationFn: async ({ email, password }) => {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        const { data:dataFT, error:errorFT } = await supabaseFreeTable.auth.signInWithPassword({ email, password });


        if (error) throw error, errorFT;
        return data, dataFT;
      },
    });
  };
  
  export const useSignOut = () => {
    return useMutation({
      mutationFn: async () => {
        const { error } = await supabase.auth.signOut();
        const {error:errorFreeTable} = await supabaseFreeTable.auth.signOut()
        if (error) throw error;
      },
    });
  };
  
  export const useUser = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchUser = async () => {
        const { data: { user } } = await supabase.auth.getUser();
        setUser(user);
        setLoading(false);
      };
  
      fetchUser();
  
      const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
        setUser(session?.user ?? null);
        setLoading(false);
      });
  
      return () => {
        authListener.subscription.unsubscribe();
      };
    }, []);
  
    return { user, loading };
  };

  